import { map } from 'rxjs/operators';
import { Injectable, NgZone } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { WebAngularSharedDataAccessFeatureFlagApisService } from '../services/feature-flags.service';

@Injectable()
export class MaintenanceGuard implements CanActivate {
  constructor(
    protected router: Router,
    private zone: NgZone,
    private featureFlagsService: WebAngularSharedDataAccessFeatureFlagApisService
  ) {}

  canActivate(): Observable<boolean> {
    return this.checkIfAppUnderMaintainence().pipe(
      map((enabled) => {
        if (!enabled) {
          return true;
        }
        this.goToMaintainenceRoute();
        return false;
      })
    );
  }

  private checkIfAppUnderMaintainence(): Observable<boolean> {
    return this.featureFlagsService.getFlagAsync('maintenance-window');
  }

  /**
   * Goes to the maintenance route
   *
   * @memberof MaintainanceGuard
   */
  private goToMaintainenceRoute() {
    // Changing route in error handling: https://github.com/angular/angular/issues/15946
    this.zone.run(() => this.router.navigate(['maintenance'], { skipLocationChange: true }));
  }
}
